import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import { useField } from 'formik';
import { checkValidLabel, NvSelect } from '@invitae/ids-react';

function NvFormikSelect(_a) {
    var name = _a.name, label = _a.label, props = __rest(_a, ["name", "label"]);
    checkValidLabel(label, name);
    var _b = __read(useField(name), 3), meta = _b[1], helpers = _b[2];
    var error = meta.touched && !!meta.error;
    var onChange = function (option) {
        helpers.setValue(option);
    };
    return (React.createElement(NvSelect, __assign({}, props, { classNamePrefix: "select", error: error, errorText: error ? meta.error : '', label: label, name: name, onChange: onChange, value: meta.value })));
}

export { NvFormikSelect, NvFormikSelect as default };
//# sourceMappingURL=NvFormikSelect.esm.js.map
